var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.2H28V6.75H10V5.2Z",
    fill: "#000FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 8H9.85999C9.60479 7.99638 9.35297 7.94112 9.11971 7.83753C8.88646 7.73395 8.67659 7.5842 8.50278 7.3973C8.32897 7.21041 8.19482 6.99025 8.1084 6.7501C8.02199 6.50995 7.98511 6.25479 7.99999 6C7.99875 5.49296 8.19014 5.00436 8.53544 4.63307C8.88075 4.26177 9.35419 4.03549 9.85999 4H29C29.2652 4 29.5196 3.89464 29.7071 3.70711C29.8946 3.51957 30 3.26522 30 3C30 2.73478 29.8946 2.48043 29.7071 2.29289C29.5196 2.10536 29.2652 2 29 2H9.85999C8.82358 2.0363 7.84177 2.47369 7.12164 3.21994C6.40151 3.96619 5.99936 4.96295 5.99999 6C5.99032 6.16319 5.99032 6.32681 5.99999 6.49C5.99036 6.56971 5.99036 6.65029 5.99999 6.73V30C5.99936 31.037 6.40151 32.0338 7.12164 32.7801C7.84177 33.5263 8.82358 33.9637 9.85999 34H29C29.2652 34 29.5196 33.8946 29.7071 33.7071C29.8946 33.5196 30 33.2652 30 33V9.07C30.0006 8.79794 29.8975 8.53587 29.7117 8.33711C29.526 8.13834 29.2715 8.0178 29 8V8ZM28 32H9.85999C9.35419 31.9645 8.88075 31.7382 8.53544 31.3669C8.19014 30.9956 7.99875 30.507 7.99999 30V9.55C8.56858 9.86367 9.2109 10.0191 9.85999 10H28V32Z",
    fill: "#000FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlue);
export default __webpack_public_path__ + "static/media/book_blue.1a96d0dc3994f8526d07e14cb7c1f8e3.svg";
export { ForwardRef as ReactComponent };